/** Portal org product entitlements (enabled_services on enterprise_salon_organizations). */

export const ORG_SERVICE_KEYS = [
  "skin_analysis",
  "hair_analysis",
  "hair_style",
  "makeup",
  "hair_coloring",
  "customer_engagement",
  "whatsapp",
];

export const ANALYSIS_ORG_SERVICE_KEYS = [
  "skin_analysis",
  "hair_analysis",
  "hair_style",
  "makeup",
  "hair_coloring",
];

export function orgHasAnalysisServices(services) {
  const list = effectiveOrgEnabledServices(services);
  return ANALYSIS_ORG_SERVICE_KEYS.some((key) => list.includes(key));
}

export function orgHasEngagementService(services) {
  return effectiveOrgEnabledServices(services).includes("customer_engagement");
}

const LEGACY_SERVICE_ALIASES = {
  video_editor: "reels",
};

const DEPRECATED_ORG_SERVICES = new Set(["reels", "video_editor"]);

export function normalizeOrgServiceKey(key) {
  const k = String(key || "").trim().toLowerCase();
  return LEGACY_SERVICE_ALIASES[k] || k;
}

export function normalizeOrgEnabledServices(raw) {
  if (!Array.isArray(raw)) return [];
  const out = [];
  const seen = new Set();
  for (const item of raw) {
    const key = normalizeOrgServiceKey(item);
    if (!key || seen.has(key) || DEPRECATED_ORG_SERVICES.has(key)) continue;
    seen.add(key);
    out.push(key);
  }
  if (seen.has("customer_engagement") && !seen.has("whatsapp")) out.push("whatsapp");
  return out;
}

export const ORG_ENTITLEMENTS_UPDATED_EVENT = "naturals-org-entitlements-updated";

/** Server-resolved list only (no client-side “assume all products”). */
export function effectiveOrgEnabledServices(raw) {
  return normalizeOrgEnabledServices(raw);
}

export function orgStorageKey(portal) {
  if (portal === "workspace") return "naturals_workspace_enabled_services";
  if (portal === "executive") return "naturals_executive_enabled_services";
  return "naturals_partner_enabled_services";
}

export function readStoredOrgEnabledServices(portal) {
  try {
    const raw = localStorage.getItem(orgStorageKey(portal));
    if (!raw) return [];
    return normalizeOrgEnabledServices(JSON.parse(raw));
  } catch {
    return [];
  }
}

export function storeOrgEnabledServices(portal, services) {
  const list = normalizeOrgEnabledServices(services);
  localStorage.setItem(orgStorageKey(portal), JSON.stringify(list));
}

export function orgHasService(services, key) {
  return effectiveOrgEnabledServices(services).includes(normalizeOrgServiceKey(key));
}

export function persistOrgEnabledServicesFromLogin(portal, data) {
  const raw = data?.enabledServices ?? data?.enabled_services;
  if (Array.isArray(raw)) {
    storeOrgEnabledServices(portal, raw);
    return true;
  }
  return false;
}
